import * as React from "react";

export interface InputContainer2023Props {
  className?: string;

  name: string;
  title?: string;
  required?: boolean;
  notice?: string;
  noticeWarningColor?: boolean;

  header?: React.FunctionComponent;

  isCustomError?: () => boolean;
  doesCustomErrorExtendStandardErrorState?: () => boolean;
  customErrorComponent?: () => React.ReactNode;

  errorValueIfAny?: string | null | undefined;
}

export const InputContainer2023: React.FunctionComponent<
  InputContainer2023Props
> = (props) => {
  const { errorValueIfAny } = props;

  const amIRenderingACustomError = props.isCustomError?.() || false;

  const doesCustomErrorExtendStandardErrorState =
    props.doesCustomErrorExtendStandardErrorState?.() || false;

  return (
    <div
      className={`input-container ${props.className || ""} ${
        errorValueIfAny || doesCustomErrorExtendStandardErrorState
          ? "error"
          : ""
      } named-${props.name}`}
    >
      {props.title && props.header ? (
        <props.header>{props.title}</props.header>
      ) : props.title ? (
        <label className="title">
          <span className="content">{props.title}</span>
          {props.required && <span className="required-asterix">&nbsp;*</span>}
        </label>
      ) : null}

      {props.notice && (
        <p
          className={`notice ${props.noticeWarningColor ? "warning" : "fine"}`}
        >
          {props.notice}
        </p>
      )}

      {props.children}

      {amIRenderingACustomError ? (
        props.customErrorComponent?.()
      ) : errorValueIfAny ? (
        <p className="error-message">{errorValueIfAny}</p>
      ) : null}
    </div>
  );
};
